<template>
    <v-autocomplete
        ref="autocomplete"
        class="title-branding custom-autocomplete"
        v-model="selected_intermediary"
        :items="intermediary_search_results"
        filled
        :search-input.sync="search"
        label="Search for intermediary"
        :disabled="disabled || forceDisabled"
        item-text="label"
        item-value="int_id"
        return-object
        truncate-length="22"
        @change="stopSearch"
        :error-messages="errorMessages"
    >
        <template v-slot:no-data>
            <v-list-item>
                <v-list-item-title
                    v-if="loading"
                >
                    Searching...
                </v-list-item-title>
                <v-list-item-title
                    v-else
                >
                    No data available
                </v-list-item-title>
            </v-list-item>
        </template>
        <template
            v-slot:append
        >
            <v-btn
                v-if="intermediarySelected"
                @click.prevent.stop="clear"
                @mouseup.prevent.stop
                icon
            >
                <v-icon
                    dark
                >
                    $mdiClose
                </v-icon>
            </v-btn>

            <v-progress-circular
                v-if="loading"
                :width="3"
                :size="20"
                :color="$vuetify.theme.dark ? 'white' : 'primary'"
                indeterminate
            ></v-progress-circular>
        </template>
    </v-autocomplete>
</template>

<script>
    export default {
        name: 'Intermediaries-Search',

        data() {
            return {
                forceDisabled: true,
                loading: false,

                selected_intermediary: {},
                intermediary_id: null,

                intermediary_search_results: [],

                search: '',

                timeout: null,
            }
        },

        computed: {
            intermediarySelected() {
                return this.selected_intermediary && typeof this.selected_intermediary.int_id !== 'undefined';
            },
        },

        watch: {
            search(val) {
                if (!val || val.toString().length < 3) {
                    return;
                }

                if (val.length > 3) {
                    this.delayedUpdateIntermediaries();
                }
            },
            'selected_intermediary'() {
                if (typeof this.selected_intermediary !== 'undefined' && typeof this.selected_intermediary.int_id !== 'undefined') {
                    this.intermediary_id = this.selected_intermediary.int_id;
                } else {
                    this.intermediary_id = null;
                }

                this.$emit('input', this.intermediary_id);

                this.$emit('update', this.selected_intermediary);
            },
        },

        props: {
            'disabled': {
                type: Boolean,
                default: false,
            },
            'value': {
                default: null,
            },
            'errorMessages': {
                type: Array,
                default: () => {[]},
            },
        },

        mounted() {
            this.updateIntermediaries();
            this.forceDisabled = false;
        },

        methods: {
            stopSearch() {
                setTimeout(() => {
                    this.loading = false;
                    clearTimeout(this.timeout);
                }, 10);
            },
            setIntermediary() {
                if (this.value !== null) {
                    this.intermediary_search_results.forEach((intermediary) => {
                        if (parseInt(intermediary.id) === parseInt(this.value)) {
                            this.selected_intermediary = intermediary;

                            this.forceDisabled = false;
                            return false;
                        }
                    });
                }

                this.forceDisabled = false;
            },
            delayedUpdateIntermediaries() {
                this.loading = true;

                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.updateIntermediaries();
                }, 1500);
            },

            updateIntermediaries() {
                window.axios.post('/broker-consultants/searchForIntermediary', {
                    search: this.search
                })
                    .then((response) => {
                        this.intermediary_search_results = response.data.intermediaries;
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.intermediary_search_results = [];
                        this.loading = false;
                    })

            },

            clear() {
                this.selected_intermediary = {};
                this.intermediary_id = null;
                this.search = '';

                this.updateIntermediaries();

                this.$refs.autocomplete.clearableCallback();
            }
        }
    }
</script>
